import React from "react";

export default function ErrMsg(props) {
  const { msg } = props;
  return <div style={{ fontSize: "12px", color: "red" }}>{msg}</div>;
}
